import { render, staticRenderFns } from "./SinglePlayer.vue?vue&type=template&id=60291c57&scoped=true&"
import script from "./SinglePlayer.vue?vue&type=script&lang=ts&"
export * from "./SinglePlayer.vue?vue&type=script&lang=ts&"
import style0 from "./SinglePlayer.vue?vue&type=style&index=0&id=60291c57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60291c57",
  null
  
)

export default component.exports